var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2788 0V13.8794H13.7212V0H10.2788ZM3.51416 3.51416C1.34258 5.68574 0 8.68628 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 8.68628 22.6574 5.68574 20.4858 3.51416L18.0688 5.93116C19.622 7.48432 20.5825 9.6302 20.5825 12C20.5825 16.7396 16.7396 20.5825 12 20.5825C7.26038 20.5825 3.41748 16.7396 3.41748 12C3.41748 9.6302 4.37798 7.48432 5.93116 5.93116L3.51416 3.51416Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.abde6cd756bcf4571213a05afd4c1ce7.svg";
export { ForwardRef as ReactComponent };